import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GridModule } from '@progress/kendo-angular-grid';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ExportToExcelService } from '../../shared/services/export-to-excel.service';
import { SharedModule } from '../../shared/shared.module';
import { AssetService } from '../asset/service/asset.service';
import { ProductAddComponent } from './components/add/product-add.component';
import { ProductDeactivateComponent } from './components/deactivate/product-deactivate.component';
import { ProductEditComponent } from './components/edit/product-edit.component';
import { DataTablePagerComponent } from './components/keywords/kewords-pager/keywords-pager.component';
import { KeywordsAddComponent } from './components/keywords/keywords-add.component';
import { KeywordsView } from './components/keywords/keywords-view/keywords-view.component';
import { LineOfServiceViewComponent } from './components/lineOfService/line-of-service-view.component';
import { ProductListComponent } from './components/list/product-list.component';
import { ProductListResultsComponent } from './components/product-list-results/product-list-results.component';
import { ProductMachineDataViewComponent } from './components/product-machine-data-view/product-machine-data-view.component';
import { ProductViewComponent } from './components/view/product-view.component';
import { ProductRoutingModule } from './product-routing.module';
import { KeywordService } from './service/keyword.service';
import { ProductService } from './service/product.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    GridModule,
    ProductRoutingModule,
    NgxDatatableModule
  ],
  providers: [
    ProductService,
    AssetService,
    ExportToExcelService,
    KeywordService
  ],
  declarations: [
    ProductListComponent,
    ProductListResultsComponent,
    ProductViewComponent,
    ProductAddComponent,
    ProductEditComponent,
    ProductDeactivateComponent,
    ProductMachineDataViewComponent,
    LineOfServiceViewComponent,
    KeywordsView,
    DataTablePagerComponent,
    KeywordsAddComponent
  ],
  exports: [ProductListComponent],
  entryComponents: [ProductDeactivateComponent, KeywordsAddComponent]
})
export class ProductModule {}
